import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import * as serviceWorker from "./serviceWorker";
import AuthService from "./app/services/auth-service";
import axios from 'axios';
//let isAlertDisplayed = false;
let isAlertDisplayed = sessionStorage.getItem('isAlertDisplayed') === 'true';


// Add a response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
        const errorMessage = error.response.data.message;
        console.log(error.response);
        if(errorMessage && errorMessage==='Invalid or missing token'){
             if (!isAlertDisplayed) {
                 isAlertDisplayed = true;
                sessionStorage.setItem('isAlertDisplayed', 'true');
                alert("Invalid authentication...");
                AuthService.clearUserInfo();
                window.location.href = '/login';
             }else{
                isAlertDisplayed = sessionStorage.getItem('isAlertDisplayed') === 'true';
            }
        }else if(errorMessage && errorMessage==='Radio Id/call sign expired'){
            if (!isAlertDisplayed) {
                isAlertDisplayed = true;
                sessionStorage.setItem('isAlertDisplayed', 'true');
                alert("Your current session has expired");
                AuthService.clearUserInfo();
                window.location.href = '/login';
            }else{
                isAlertDisplayed = sessionStorage.getItem('isAlertDisplayed') === 'true';
            }
        }else{
          return Promise.reject(error);
        }
    }else{
        return Promise.reject(error);
    }    
  }
);


ReactDOM.render(
  <BrowserRouter basename="/">
      <App />
  </BrowserRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();
